import { render, staticRenderFns } from "./addWorks.vue?vue&type=template&id=62ee8ec0&scoped=true&"
import script from "./addWorks.vue?vue&type=script&lang=js&"
export * from "./addWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ee8ec0",
  null
  
)

export default component.exports